import React from "react";
import Page from "../components/page";

const Mailto = ({ email, subject = '', body = '', children }) => {
  let params = subject || body ? '?' : '';
  if (subject) params += `subject=${encodeURIComponent(subject)}`;
  if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

  return <a href={`mailto:${email}${params}`}>{children}</a>;
};

const ContactUsPage = (props) => {
  const pageTitle="Contact Us | CBB Ratings";
  const seoDescription="Contact cbbratings.com with feedback, suggestions, or questions about college basketball ratings and matchup predictions.";
  const pageHeading="Contact CBB Ratings"
  const subHeading="Questions, feedback, or data issues"
  return (
    <Page
      location={props.location.href}
      pageTitle={pageTitle}
      seoDescription={seoDescription}
      pageHeading={pageHeading}
      subHeading={subHeading}
    >
          <p>Help us make this site better.  Send any feedback, suggestions, or ideas to:&nbsp;
          <Mailto email="tradingsolutions@harsip.com" subject={`cbbratings.com feedback`} >
            tradingsolutions@harsip.com
          </Mailto></p>
      </Page>);
  
};

export default ContactUsPage;